module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("By ")]), _vm._v("A"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("SHLYN")]), _vm._v(" K"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("ANE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("OVELS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("American Love Songs")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("A Good Vintage")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ITH")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ETHANY")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ROWN")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("OST")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("OYS")]), _c('span', {
    staticClass: "t1"
  }), _c('span', {
    staticClass: "t6"
  }, [_vm._v("AND")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" L")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("OVE")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" L")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ETTERS")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("True North")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Picture Perfect")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Wild Angels")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Broken Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ITH")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" M")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("ORGAN")]), _c('span', {
    staticClass: "t1"
  }, [_vm._v(" J")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("AMES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Hair of the Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Return to Sender")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Published by ")]), _vm._v("D"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0